import React from 'react';
import { Link } from 'react-router-dom';

type PublicSiteHeaderProps = {
  currentPage?: 'home' | 'about';
};

const PublicSiteHeader: React.FC<PublicSiteHeaderProps> = ({ currentPage = 'home' }) => {
  return (
    <nav
      className="bg-white/95 backdrop-blur-sm shadow-sm border-b border-gray-200"
      aria-label="Main navigation"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link
            to="/"
            className="flex items-center space-x-3"
            aria-label="VECTOR Athletic Performance System - Home"
          >
            <img
              src="https://lurganoidebucketire.s3.eu-north-1.amazonaws.com/unleashed/materials/logo-full.png"
              alt="VECTOR Athletic Performance System"
              className="h-12 w-auto"
            />
            <span className="hidden sm:inline text-lg font-bold text-secondary">
              VECTOR Athletic Performance System
            </span>
          </Link>
          <div className="flex items-center gap-1 sm:gap-3">
            <Link
              to="/about"
              className={`inline-flex items-center px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ${
                currentPage === 'about'
                  ? 'text-primary bg-primary/10'
                  : 'text-gray-700 hover:text-primary hover:bg-primary/5'
              }`}
              aria-current={currentPage === 'about' ? 'page' : undefined}
            >
              About
            </Link>
            <Link
              to="/login"
              className="inline-flex items-center px-4 py-2 text-sm font-medium text-primary hover:text-primary-dark hover:bg-primary/5 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
              aria-label="Sign in"
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default PublicSiteHeader;
